import { useGetClientProfile } from '@/api/clients/get-client-profile'
import { useGetGuestPassProfile } from '@/api/clients/get-guest-pass-profile'
import { DEFAULT_TZ } from '@/constants/date'
import { useFilters } from '@/hooks/use-filters'

import { INITIAL_FILTERS } from './guest-passes.constants'
import * as S from './guest-passes.styled'
import { GuestPassesProps } from './guest-passes.types'
import { GuestPassesAllocation } from './guest-passes-allocation'
import { GuestPassesCheckins } from './guest-passes-checkins'

export const GuestPasses = ({ clientId }: GuestPassesProps) => {
  // Note: sourced from the resident's own building, not the globally selected
  // one — switching the top building selector while a profile is open must
  // not toggle this section (or its timezone) based on another building.
  const { data: clientData, isLoading: isClientLoading } = useGetClientProfile({ clientId })
  const amenityPassesAvailable = clientData?.buildingId.amenityPassesAvailable ?? false
  const timezone = clientData?.buildingId.timezone ?? DEFAULT_TZ

  const tableFilters = useFilters({ initialState: INITIAL_FILTERS })
  const { skip, limit } = tableFilters.filters

  const { data, isFetching } = useGetGuestPassProfile({ clientId, limit, skip })

  if (isClientLoading || !amenityPassesAvailable) return null

  const totalPasses = data?.totalGuestPasses ?? 0
  const usedPasses = data?.usedGuestPasses ?? 0
  const visits = data?.guestPassVisits ?? []
  const total = data?.total ?? 0

  return (
    <S.Container>
      <GuestPassesAllocation
        clientId={clientId}
        totalPasses={totalPasses}
        usedPasses={usedPasses}
        isLoading={isFetching}
      />
      <GuestPassesCheckins
        amenityClientId={data?.id ?? ''}
        clientId={clientId}
        visits={visits}
        total={total}
        isLoading={isFetching}
        tableFilters={tableFilters}
        timezone={timezone}
      />
    </S.Container>
  )
}
